import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsJobWorkflowTaskClearState } from 'reducers/translations/jobWorkflowTask/reducer'
import JobWorkflowTaskList from './JobWorkflowTaskList'
import JobWorkflowTaskItem from './JobWorkflowTaskItem'

function JobWorkflowTask(props) {
  const {
    match: {
      params: { id },
    },
    translationsJobWorkflowTaskClearState,
  } = props
  const JobWorkflowTaskContent = id ? JobWorkflowTaskItem : JobWorkflowTaskList

  useEffect(
    () => () => {
      translationsJobWorkflowTaskClearState()
    },
    [],
  )

  return (
    <div className="content">
      <JobWorkflowTaskContent {...props} />
    </div>
  )
}

JobWorkflowTask.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsJobWorkflowTaskClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsJobWorkflowTaskClearState,
})(JobWorkflowTask)
